import React from "react";
import CmmsSettings from "../features/cmmsSettings";

export default function CmmsSettingsPage() {
  return (
    <CmmsSettings />
  );
}
